const vars = {
  env: import.meta.env.MODE,
  console: (import.meta.env.VITE_APP_ENABLE_CONSOLE === 'true'),
  mocks: {
    locales: (import.meta.env.VITE_APP_ENABLE_MOCKS_LOCALES === 'true'),
    rest: (import.meta.env.VITE_APP_ENABLE_MOCKS === 'true'),
  },
  onlyTranslationMocks: (import.meta.env.VITE_APP_ENABLE_MOCKS_LOCALES === 'false'),
  request: {
    baseUrl: import.meta.env.VITE_APP_REQUEST_BASEURL,
    pdfBaseUrl: import.meta.env.VITE_APP_PDF_REQUEST_BASEURL,
    timeout: import.meta.env.VITE_APP_REQUEST_TIMEOUT,
  },
  sentry: {
    dsn: import.meta.env.VITE_APP_SENTRY_DSN,
  },
};

export default vars;
